// extracted by mini-css-extract-plugin
module.exports = {"footerCopyright":"Copyright_footer-copyright__cFZD2","footerCopyrightText":"Copyright_footer-copyright-text__wKjCN"};